import React from 'react';
import { useTheme } from '@planne-software/uni/mui/material';
import { IconMailForward, IconLock } from '@tabler/icons-react';
import { useTranslate } from '@src/core/hooks';
import { BadgeContent, BadgeDescription, BadgeRow, BadgeTitle, Container, Wrapper } from './styles';

const TrustBadges = () => {
  const { i18n } = useTranslate();
  const theme = useTheme();

  return (
    <Wrapper>
      <Container>
        <Badge
          icon={<IconMailForward size={24} color={theme.tokens.colors['icon-color-primary-base']} />}
          title={i18n('product_booking_trust_instant_title')}
          description={i18n('product_booking_trust_instant_description')}
        />
        <Badge
          icon={<IconLock size={24} color={theme.tokens.colors['icon-color-success-stronger']} />}
          title={i18n('product_booking_trust_secure_title')}
          description={i18n('product_booking_trust_secure_description')}
        />
      </Container>
    </Wrapper>
  );
};

const Badge = ({ icon, title, description }: { icon: React.ReactNode; title: string; description: string }) => (
  <BadgeRow>
    {icon}
    <BadgeContent>
      <BadgeTitle>{title}</BadgeTitle>
      <BadgeDescription>{description}</BadgeDescription>
    </BadgeContent>
  </BadgeRow>
);

export default TrustBadges;
